import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class OthersRoute extends Route {
  @service store;

  crumb() {
    return {
      name: "Doesn't Belong To",
      path: this.routeName,
    };
  }

  model() {
    let person = this.modelFor('person');

    return this.store.findAll('segment').then((segments) => {
      return person.get('segments').then((personSegments) => {
        let personSegmentIds = personSegments.mapBy('id');

        return segments.filter((segment) => {
          return !personSegmentIds.includes(segment.id);
        });
      });
    });
  }
}
